module.exports = __webpack_public_path__ + "static/media/zippyclip-3.92b80e8d.jpg";